// extracted by mini-css-extract-plugin
export default {"settings":"QwK3hQ5BHwAASRzUSBHE"};